import { postForgotPassword } from 'api/calls'
import { Button } from 'components/atoms'
import { LoginType } from 'components/types/Context'
import { ForgotPWreq, ModalType } from 'components/types/types'
import { useFormik } from 'formik'
import React, { FC, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'
import { useAuth } from 'shared/auth'
import { emailRegex } from 'shared/const'
import * as Yup from "yup";

export type FPProps = {
 whoLogsIn: LoginType
}

export const  ForgotPassword:FC<FPProps> = ({whoLogsIn}) =>{

    
    const {
        setLoadingModal,
        setErrorModal,
        setIsChooseNewPassword,setIsForgotPassword,
        setModal,
        isForgotPassword, setForgotPWNewEmail
      } = useContext(AppGeneralContext)
    const { saveAuth, setCurrentUser } = useAuth()

      
    const forgotPWSchema = Yup.object().shape({
        email: Yup.string()
          .matches(emailRegex, 'Wrong email format')
          .required('Please complete this required field.'),
      });

    const formikforgotPW = useFormik<ForgotPWreq>({
        initialValues: { email: "", isStartup: whoLogsIn === LoginType.startup },
        validationSchema: forgotPWSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
          setSubmitting(true)
          setLoadingModal();
    
          const forgotPasswordResponse = await postForgotPassword(values);
    
          if (!forgotPasswordResponse.isSuccess || !forgotPasswordResponse.response) {
            saveAuth(null)
            setSubmitting(false)
            setErrorModal(!!forgotPasswordResponse.error ? forgotPasswordResponse.error : "Something went wrong!")
            return
          }
    
          setModal({ isOpen: true, type: ModalType.error, title: "Forgot Password", message: "Your request has been submitted. You will receive by e-mail a code to verify your identity." })
          setForgotPWNewEmail(values.email)
          setIsChooseNewPassword(true)
          setIsForgotPassword(false)
        }
      })

      useEffect(()=>{
        if(!isForgotPassword){
             setIsChooseNewPassword(false);
             formikforgotPW.setFieldValue("email", ""); 
             formikforgotPW.setFieldTouched("email", false) ;
        }
      },[isForgotPassword ])

      
  return (
    <form onSubmit={formikforgotPW.handleSubmit} autoComplete='off' id='formForgotPW' >
    {/* email*/}
    <label className='text-black mt-3' htmlFor="user">Email<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
    <input
      autoComplete="new-password"
      placeholder='Your Email'
      {...formikforgotPW.getFieldProps('email')}
      className="form-input"
      type="text"
      onChange={formikforgotPW.handleChange}
      onBlur={() => formikforgotPW.setFieldTouched("email", true)}
      value={formikforgotPW.values.email}
      name="email"
    />
    {formikforgotPW.errors.email && formikforgotPW.touched.email && <div className='text-error ms-2' id="user">{formikforgotPW.errors.email}</div>}
    <div className='d-flex justify-content-end'>
      <p onClick={() => { setIsForgotPassword(false); formikforgotPW.setFieldValue("email", ""); formikforgotPW.setFieldTouched("email", false) }} className='tx-primary cursor-pointer mt-3'>Cancel</p>
    </div>
    <Button form="formForgotPW"
      type='submit'
      className='mt-5 ms-1 ' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary text='submit' />
  </form >
  )
}
